"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnualEarnedIncome = AnnualEarnedIncome;
exports.BirthDay = BirthDay;
exports.CashSavings = CashSavings;
exports.EstimatedMonthlyExpenses = EstimatedMonthlyExpenses;
exports.HaveEmployerPlanTransform = HaveEmployerPlanTransform;
exports.InflationRate = InflationRate;
exports.MonthlyCap = MonthlyCap;
exports.MutualFundsStocksSavings = MutualFundsStocksSavings;
exports.NumOfYearsCovered = NumOfYearsCovered;
exports.OtherAnnualIncome = OtherAnnualIncome;
exports.OtherIncomeCovered = OtherIncomeCovered;
exports.PercentOfIncomeCovered = PercentOfIncomeCovered;
exports.RetirementAge = RetirementAge;
exports.RetirementSavings = RetirementSavings;
exports.SalaryGrowthRate = SalaryGrowthRate;
exports.TaxRate = TaxRate;
exports.YearsToCover = YearsToCover;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _DropdownForForm = require("../Wizard/DropdownForForm");
var _DisabilityWizardCalculator = require("./DisabilityWizardCalculator.config");
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _DropdownSelect = _interopRequireDefault(require("react-blueprint-library/build/cjs/Dropdown/DropdownSelect"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// TEXT INPUT FIELDS START HERE
function BirthDay(props) {
  var {
    errors,
    touched,
    birthDay,
    birthMonth,
    birthYear,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = props;

  // Set birthdate field based on three separate, dependent fields
  _react.default.useEffect(() => {
    var parsedDate = (0, _parse.default)("".concat(birthMonth, "-").concat(birthDay, "-").concat(birthYear), 'M-d-y', new Date());
    setFieldValue('birthdate', parsedDate);
  }, [birthDay, birthMonth, birthYear, touched.birthdate, setFieldValue]);

  // Set birthdate touched after all three fields have been touched
  _react.default.useEffect(() => {
    setFieldTouched('birthdate', touched.birthMonth && touched.birthDay && touched.birthYear);
  }, [touched.birthDay, touched.birthMonth, touched.birthYear]);

  // Override errors in order sequential order
  _react.default.useEffect(() => {
    var firstBirthdateError = [errors.birthMonth, errors.birthDay, errors.birthYear, errors.birthdate].find(val => !!val);
    setFieldError('birthdate', firstBirthdateError);
  }, [errors.birthDay, errors.birthMonth, errors.birthYear, touched.birthDay, touched.birthMonth, touched.birthYear]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "birthMonth"
  }, "Birth Month"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    name: "birthMonth",
    "aria-label": "di_birthMonth",
    id: "di_birthMonth",
    placeholder: "MM",
    maxLength: "2",
    value: birthMonth,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, 'monthOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "birthDay"
  }, "Birth Day"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    name: "birthDay",
    "aria-label": "di_birthDay",
    id: "di_birthDay",
    placeholder: "DD",
    maxLength: "2",
    value: birthDay,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, 'dayOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "birthYear"
  }, "Birth Year"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    name: "birthYear",
    "aria-label": "di_birthYear",
    id: "di_birthYear",
    placeholder: "YYYY",
    maxLength: "4",
    value: birthYear,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, 'yearOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    className: "custom-feedback",
    type: "invalid"
  }, errors.birthdate)));
}
function AnnualEarnedIncome(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'annualEarnedIncome';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Annual Salary (before taxes)",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function OtherAnnualIncome(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'otherAnnualIncome';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Annual Bonus/Commissions",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function TaxRate(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'taxRate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Tax Rate",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function RetirementAge(_ref) {
  var {
    errors,
    touched,
    values
  } = _ref;
  var fieldName = 'retirementAge';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Retirement Age",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "3",
    placeholder: "00",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function YearsToCover(_ref2) {
  var {
    errors,
    touched,
    values
  } = _ref2;
  var fieldName = 'yearsToCover';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Years to Cover",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "3",
    placeholder: "00",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function CashSavings(_ref3) {
  var {
    errors,
    touched,
    values
  } = _ref3;
  var fieldName = 'cashSavings';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Cash Savings",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function RetirementSavings(_ref4) {
  var {
    errors,
    touched,
    values
  } = _ref4;
  var fieldName = 'retirementSavings';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "401K or IRA",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function MutualFundsStocksSavings(_ref5) {
  var {
    errors,
    touched,
    values
  } = _ref5;
  var fieldName = 'mutualFundsStocksSavings';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Mutual Funds/Stocks",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function EstimatedMonthlyExpenses(_ref6) {
  var {
    errors,
    touched,
    values
  } = _ref6;
  var fieldName = 'estimatedMonthlyExpenses';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Monthly Expenses",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function PercentOfIncomeCovered(_ref7) {
  var {
    errors,
    touched,
    values
  } = _ref7;
  var fieldName = 'percentOfIncomeCovered';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Percentage of income covered?",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function NumOfYearsCovered(_ref8) {
  var {
    errors,
    touched,
    values
  } = _ref8;
  var fieldName = 'numOfYearsCovered';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Number of years benefits can be paid",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "3",
    placeholder: "00",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function MonthlyCap(_ref9) {
  var {
    errors,
    touched,
    values
  } = _ref9;
  var fieldName = 'monthlyCap';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Monthly cap on disability payments",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "00,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function SalaryGrowthRate(_ref10) {
  var {
    errors,
    touched,
    values
  } = _ref10;
  var fieldName = 'salaryGrowthRate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Salary Growth",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: "Represents the annual increase in salary you expect to receive through retirement."
  });
}
function InflationRate(_ref11) {
  var {
    errors,
    touched,
    values
  } = _ref11;
  var fieldName = 'inflationRate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    label: "Inflation",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: "Represents the increase in overall price levels."
  });
}
function HaveEmployerPlanTransform(props) {
  var {
    values,
    setFieldValue
  } = props;
  var fieldName = 'haveEmployerPlanTransform';
  var label = 'Do you have an existing plan?';
  var placeholderText = 'Select One';
  var dataArray = _DisabilityWizardCalculator.dropdownOptions.haveEmployePlanTransfer;
  var transformMap = {
    Yes: 'have',
    No: "don't have"
  };
  var handleDropdownOnSelect = (value, field, setFieldValue) => {
    setFieldValue(field, value);
    if (field && typeof utag === 'object' && utag.link && value) {
      utag.link({
        event_category: _DisabilityWizardCalculator.calcName,
        event_action: 'field_input',
        event_label: field,
        event_property: value
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: fieldName
  }, label), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_DropdownSelect.default, {
    data: dataArray,
    onSelect: value => {
      setFieldValue('haveEmployerPlan', transformMap[value]);
      return handleDropdownOnSelect(value, fieldName, setFieldValue);
    },
    defaultLabel: values[fieldName] != '' ? values[fieldName] : placeholderText || 'Select One',
    toggleId: fieldName,
    toggleName: fieldName
  })));
}
function OtherIncomeCovered(props) {
  var {
    values,
    setFieldValue
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "otherIncomeCovered",
    setFieldValue: setFieldValue,
    values: values,
    label: "Are annual bonus/commisions covered?",
    placeholderText: "Select One",
    dataArray: _DisabilityWizardCalculator.dropdownOptions.otherIncomeCovered,
    calcName: _DisabilityWizardCalculator.calcName
  }));
}